module.exports = __webpack_public_path__ + "assets/img/free_5.6821b2bd.png";